<script>
	import {type2Style} from './lists.js'

	export let label = "";
	export let type;
</script>

<span style={type2Style(type)}>{label}</span>
